import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import { Divider, List, useTheme } from '@mui/material';
import { TextM } from '../typography';
import {
  ListItemButtonContent,
  ListItemButtonWrapper,
  SideMenuDrawerItemContainer,
  SideMenuDrawerItemContainerCollapsed,
} from './styles';

export interface ISideMenuDrawerItemProps {
  icon?: React.ReactNode;
  hoverIcon?: React.ReactNode;
  title: string;
  isOpen?: boolean;
  children?: React.ReactNode;
  multiple?: boolean;
  selected?: boolean;
  isCollapsed?: boolean;
  handleClick?: () => void;
}

const SideMenuDrawerItem = ({
  icon,
  title,
  hoverIcon,
  children,
  isOpen = false,
  multiple = false,
  selected = false,
  isCollapsed = false,
  handleClick,
}: ISideMenuDrawerItemProps) => {
  const theme = useTheme();
  const onButtonClick = () => {
    handleClick?.();
  };

  return (
    <SideMenuDrawerItemContainer isSelected={selected}>
      {isCollapsed ? (
        <SideMenuDrawerItemContainerCollapsed
          isSelected={selected}
          onClick={handleClick}
        >
          <ListItemButton>{selected ? hoverIcon : icon}</ListItemButton>
        </SideMenuDrawerItemContainerCollapsed>
      ) : (
        <>
          <ListItemButton onClick={onButtonClick}>
            <ListItemButtonWrapper>
              <ListItemButtonContent isOpen={isOpen}>
                <div className="title-area">
                  {selected ? hoverIcon : icon}
                  <TextM weight="Bold">{title}</TextM>
                </div>
                {multiple && (
                  <div className="arrowico">
                    <KeyboardArrowDownOutlinedIcon />
                  </div>
                )}
              </ListItemButtonContent>
            </ListItemButtonWrapper>
          </ListItemButton>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Divider color={theme.palette.common.white} />
            <List style={{ padding: '0 1rem' }} disablePadding>
              {children}
            </List>
          </Collapse>
        </>
      )}
    </SideMenuDrawerItemContainer>
  );
};

export default SideMenuDrawerItem;
